import React from "react";

/**
 * Official Adtree Go wordmark, CSS-built (crisp at any size).
 * Variants: "default" (white ADTREE + yellow GO) / "inverse" (black ADTREE + yellow GO on light bg)
 * Sizes:    "sm" (navbar mobile), "md" (navbar desktop), "lg" (footer/admin), "xl"
 */
const SIZE = {
  sm: { text: "text-xl", go: "text-[9px] px-1 py-1", gap: "gap-1" },
  md: { text: "text-2xl md:text-[1.7rem]", go: "text-[10px] px-1.5 py-1", gap: "gap-1.5" },
  lg: { text: "text-3xl md:text-4xl", go: "text-xs px-2 py-1.5", gap: "gap-2" },
  xl: { text: "text-4xl md:text-5xl", go: "text-sm px-2.5 py-2", gap: "gap-2.5" },
};

const AdtreeLogo = ({ size = "md", variant = "default", className = "", testId = "adtree-logo" }) => {
  const s = SIZE[size] || SIZE.md;
  const wordColor = variant === "inverse" ? "text-black" : "text-white";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-stretch ${s.gap} ${className}`}
      aria-label="Adtree Go"
    >
      <span
        className={`font-anton uppercase tracking-[0.01em] leading-[0.85] ${s.text} ${wordColor}`}
        style={{ fontStretch: "condensed" }}
      >
        ADTREE
      </span>
      <span
        className={`bg-brand-yellow text-black font-anton uppercase tracking-wider flex items-center justify-center leading-none ${s.go}`}
      >
        GO
      </span>
    </span>
  );
};

export default AdtreeLogo;
